import { useUser } from '@hooks';
import TaskTable from './TaskTable';

type Props = Omit<Parameters<typeof TaskTable>[0], 'userId'>;

const TaskList: React.FC<Props> = ({
  ...props
}) => {
  const [user] = useUser();
  const userId = user?.id;

  if (!userId) {
    return null;
  }

  return (
    <TaskTable
      userId={userId}
      isLoading={props.isLoading}
      {...props}
    />
  );
};

export default TaskList;
